import { render, staticRenderFns } from "./msg404.vue?vue&type=template&id=6acf0b05&scoped=true&"
import script from "./msg404.vue?vue&type=script&lang=js&"
export * from "./msg404.vue?vue&type=script&lang=js&"
import style0 from "./msg404.vue?vue&type=style&index=0&id=6acf0b05&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf0b05",
  null
  
)

export default component.exports